module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "city-goods"
  }, [_c('img', {
    staticClass: "city-goods-img",
    attrs: {
      "src": require("../assets/newImg/pic-index-banner.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "city-goods-name"
  }, [_vm._v("小厨娘8人套餐只要99元")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "city-goods-tip"
  }, [_c('GoodsTips')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "city-detail"
  }, [_c('div', {
    staticClass: "city-detail-left"
  }, [_c('div', {
    staticClass: "city-goods-price"
  }, [_c('span', [_vm._v("¥")]), _vm._v("19.9\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "city-goods-tprice"
  }, [_vm._v("\n\t\t\t\t¥348\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "city-goods-earn"
  }, [_vm._v("预估收益￥28.00")])]), _vm._v(" "), _c('div', {
    staticClass: "city-goods-sell"
  }, [_vm._v(" 已售 32")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eba222a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GoodsItem3.vue
// module id = 2628
// module chunks = 0